<main *ngIf="borrower$ | async as borrower">
  <div *ngIf="borrower.isCustom;else defaultletter">
    <div *ngFor="let asset of borrowerPdf.assetArray">
    <img [src]="asset"/>
  </div>
  </div>
<ng-template #defaultletter>

  <div class="logo-container">
    <img src={{borrower.loanOfficer.companyLogoUrl}} alt="Best Offer Package Logo">
  </div>

  <div class="date">{{ currentDate | date:'longDate' }}</div>

  <div class="letter-title">
    <span>Conditional Loan Approval</span>
  </div>

  <div class="letter-content">
    <div class="name">Dear {{borrower.fullName}}{{ borrower.coBorrower.fullName?(' and ' + borrower.coBorrower.fullName):''}}, </div> 
    <div class="congratulations">
      <p class="congratulations-section">
        Congratulations! Thank you for choosing {{borrower.loanOfficer.companyName ? borrower.loanOfficer.companyName : 'Best Offer Package'}} to represent you in
        securing your mortgage financing. We are confident we can provide
        you with the most efficient home loan process available.
      </p>
      We have reviewed your income, assets, credit and are pleased to inform you that we
      have <strong>approved</strong> your request.
    </div>

    <div class="pre-approval">
      <p class="pre-approval-title">Below is a summary of your pre-approval:</p>
      <div class="pre-approval-info">
        <div class="row">
          <div *ngIf="borrower.preApproval.purchasePrice==null; then purchaseThen else purchaseElse">      
          </div>  
          <ng-template #purchaseThen> 
            <span class="title">Purchase Price:</span>
            <span class="value">{{borrower.preApproval.maxPurchasePrice | currency}}</span>  
          </ng-template>           
          <ng-template #purchaseElse>          
            <span class="title">Purchase Price:</span>
            <span class="value">{{  borrower.preApproval.purchasePrice | currency }}</span>            
          </ng-template>       
        </div>
        <div class="row">
          <div *ngIf="borrower.preApproval.address=='' || borrower.preApproval.address==null; then addressThen else addressElse">      
          </div>  
          <ng-template #addressThen> 
            <span class="title">Address:</span>
            <span class="value">TBD</span>  
          </ng-template>           
          <ng-template #addressElse>          
            <span class="title">Address:</span>
            <span class="value">{{  borrower.preApproval.address }}</span>            
          </ng-template>       
        </div>
        <div class="row" *ngIf="defaultFieldsShow.Downpayment">
          <span class="title">Down Payment:</span>
          <span class="value" *ngIf="borrower.preApproval.downPaymentType !== 1">{{ borrower.preApproval.downPayment | currency }}</span>
          <span class="value" *ngIf="borrower.preApproval.downPaymentType == 1">{{ borrower.preApproval.downPayment }}%</span>
        </div>
        <div class="row" *ngIf="defaultFieldsShow['Property type']">
          <span class="title">Property Type:</span>
          <span class="value">{{ toReadablePropertyType(borrower.preApproval.propertyType) }}</span>
        </div>
        <div class="row" *ngIf="defaultFieldsShow.Occupancy">
          <span class="title">Occupancy:</span>
          <span class="value">{{ toReadableOccupancy(borrower.preApproval.occupancy) }}</span>
        </div>
        <div class="row" *ngIf="defaultFieldsShow.Fico">
          <span class="title">FICO:</span>
          <span class="value">{{ borrower.preApproval.fico }}</span>
        </div>
        <div class="row" *ngIf="defaultFieldsShow['Program type']">
          <span class="title">Program:</span>
          <span class="value">{{ toReadableProgramType(borrower.preApproval.program) }}</span>
        </div>
        <div class="row" *ngFor="let customField of borrowerCustomFields">
          <ng-container *ngIf="customField?.isDefault">
            <ng-container *ngIf="customField.customFieldName === 'Property type' && customField.isChecked">
              <span class="title">Property Type:</span>
              <span class="value">{{ toReadablePropertyType(borrower.preApproval.propertyType) }}</span>
            </ng-container>
            <ng-container *ngIf="customField.customFieldName === 'Occupancy' && customField.isChecked">
              <span class="title">Occupancy:</span>
              <span class="value">{{ toReadableOccupancy(borrower.preApproval.occupancy) }}</span>
            </ng-container>
            <ng-container *ngIf="customField.customFieldName === 'Fico' && customField.isChecked">
              <span class="title">FICO:</span>
              <span class="value">{{ borrower.preApproval.fico }}</span>
            </ng-container>
            <ng-container *ngIf="customField.customFieldName === 'Program type' && customField.isChecked">
              <span class="title">Program Type:</span>
              <span class="value">{{ toReadableProgramType(borrower.preApproval.program) }}</span>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="customField.customeFieldValue">
          <span class="title" *ngIf="customField.isShow">{{customField.customFieldName}}:</span>
          <span class="value">{{showCustomField(customField.customeFieldValue,customField.inputType)}}</span>
        </ng-container>
        </div>
      </div>
    </div>

    <div class="conditions">
      <p>This approval is subject to the following conditions: </p>
      <p>1.)&nbsp; The property must meet all investor collateral requirements </p>
      <p>2.)&nbsp; Issuance of Title and Hazard Insurance satisfactory to our company </p>
      <p>3.)&nbsp; Satisfaction of any special conditions as required </p>
    </div>

    <div class="contacts">
      Please do not hesitate to contact me directly at {{ borrower.loanOfficer.phoneNumber }} with any questions
      regarding this approval.
    </div>

    <div class="conclusion">
      <p class="conclusion-section">
        We look forward to servicing your future real estate financing needs and the needs of
        your friends, family, and colleagues.
      </p>
    </div>
    <div class="summary-signatures">
      Thank you,
      <span class="image" *ngIf="borrower.loanOfficer.signatureUrl as loanOfficerOfferSignature">
        <img [src]="loanOfficerOfferSignature" alt="Loan officer offer signature">
      </span>
      <span class="lo-name">
        {{ borrower.loanOfficer.fullName }}
      </span>
      <div class="company-name">{{borrower.loanOfficer.title}}</div>
    </div>
    <div class="company-name">{{borrower.loanOfficer.companyName ? borrower.loanOfficer.companyName : 'Best Offer Package'}}</div>
    <div>NMLS ID : {{borrower.loanOfficer.nmlsId}}</div>
    <div class="company-contacts">
      <div>{{borrower.loanOfficer.email}}</div>
      <div>{{borrower.loanOfficer.phoneNumber}}</div>
    </div>
  </div>
</ng-template>
</main>